import Link from 'next/link';
import { ComponentProps, FC, Fragment, JSX, useContext } from 'react';
import type { Space, Venue } from 'types/domain';
import { useTranslation } from 'utils/i18n';

import { AuthContext } from '../../state/auth';

import FeatureIconBase from '../shared/featureIcon';

const FeatureIcon = FeatureIconBase as FC<
  Partial<ComponentProps<typeof FeatureIconBase>> &
    Pick<ComponentProps<typeof FeatureIconBase>, 'type' | 'name'>
>;

interface Props {
  venue: Pick<Venue, 'id'> & Partial<Pick<Venue, 'floorplans'>>;
  space?: Pick<Space, 'id' | 'floor' | 'floorplan'>;
  wrapper?: keyof JSX.IntrinsicElements | FC;
}

const FloorplansButton = ({
  venue,
  space,
  wrapper: Wrapper = Fragment,
}: Props) => {
  const { t } = useTranslation('common');
  const { loggedIn, accountApproved } = useContext(AuthContext);

  const userIsApproved = loggedIn && accountApproved;

  const floorplan = space
    ? !!space.floorplan
    : venue.floorplans && !!venue.floorplans.length;

  const location = space
    ? `/properties/${venue.id}/floorplans?spaceId=${space.id}`
    : `/properties/${venue.id}/floorplans`;

  return userIsApproved && floorplan ? (
    <Wrapper>
      <Link
        href={location}
        data-testid="floorPlansLink"
        className="venue__floorplans"
      >
        <FeatureIcon
          type="floorplan"
          name={t('feature_icon.view_floorplan')}
          displaySvgIcon
        />
      </Link>
    </Wrapper>
  ) : null;
};

export default FloorplansButton;
